<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Alerts"></app-sub-header>
                        <div class="margin-b" style="text-align: end;">
                            <button routerLink='/create-alerts' class="btn  main-backgroundcolor color">Create
                                Alert</button>
                        </div>

                    </div>
                </div>
                <app-no-results-found *ngIf="alertsArr.length == 0 && loading" title='Alerts'></app-no-results-found>
                <!-- <div *ngFor="let props of (objArr | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: pageNo,
                        totalItems: totalItems
                      }) let i = index">
                    <app-alert-card *ngIf="loading" [size]=1 [data]="props" (alertCreated)="refreshAlerts()"></app-alert-card>
                </div> -->

                <div *ngFor="let props of (objArr | paginate: { itemsPerPage: pageSize, currentPage: pageNo, totalItems: totalItems }) let i = index">
                  <app-alert-card *ngIf="loading" [size]="1" [data]="props" (alertCreated)="refreshAlerts()"></app-alert-card>
                </div>

                <div *ngIf="!loading">
                    <div *ngFor="let props of arr">
                        <app-card-skelton></app-card-skelton>
                    </div>
                </div>

                <div *ngIf="objArr?.length > 8" class="col-md-12" style="text-align: center;">
                    <!-- <app-pagination [maxSize]="pageSize" (pageChange)="page = onChange($event)"></app-pagination> -->
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="objArr?.length > 0 "
                        (pageChange)="page = getAlerts($event)" directionLinks="true" autoHide="false" responsive="true"
                        previousLabel="Previous" nextLabel="Next" screenReaderPaginationLabel="Pagination"
                        screenReaderPageLabel="page" screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>

            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
